import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem('cookiesAccepted', 'false');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] border-t border-border bg-surface p-4 md:p-5">
      <div className="mx-auto flex max-w-5xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-[13px] leading-[1.5] text-ink-soft">
          {t('cookie.text')}{' '}
          <a href="/cookies" className="font-medium text-primary hover:underline">{t('cookie.policy')}</a>.
        </p>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={reject}
            className="rounded-md border border-border bg-white px-4 py-2 text-[13px] font-medium text-ink-soft transition hover:border-primary cursor-pointer"
          >
            {t('cookie.reject')}
          </button>
          <button
            type="button"
            onClick={accept}
            className="rounded-md bg-primary px-4 py-2 text-[13px] font-semibold text-white transition hover:bg-primary-hover cursor-pointer"
          >
            {t('cookie.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}